// Data seam for the crypto holdings, mirroring src/data/notes.js.
//
// Wallets are org-wide, like everything on the signed-in pages. Addresses are
// public by nature; the keys that read them stay on the server.

import { request } from './portfolio';

/** Resolves to `{ asOf, wallets, rows, hidden }`. Balances and prices are
 *  read live on every call. */
export const getCrypto = () => request('crypto');

export const addWallet = ({ chain, address, label }) =>
  request('crypto/wallets', {
    method: 'POST',
    body: JSON.stringify({ chain, address, label: label || null }),
  });

/** Names a wallet, as a broker connection gets a nickname. An empty name
 *  clears it and the page falls back to the shortened address. */
export const renameWallet = (id, label) =>
  request(`crypto/wallets/${encodeURIComponent(id)}/label`, {
    method: 'PUT',
    body: JSON.stringify({ label }),
  });

/** Deletes the wallet and the history indexed for it. */
export const removeWallet = (id) =>
  request(`crypto/wallets/${encodeURIComponent(id)}`, { method: 'DELETE' });

/**
 * Advances the on-chain history by one bounded run (about 20 seconds).
 * Resolves to `{ done }`; call again until it is true. A first backfill of a
 * busy wallet takes several runs, and each has to finish inside the gateway's
 * 30-second limit.
 */
export const syncCrypto = () => request('crypto/sync', { method: 'POST' });

/**
 * The NFTs every tracked EVM wallet holds, grouped by collection. Resolves to
 * `{ collections, totals, pending }`: read from what the sync stored, so it is
 * as fresh as the last `syncCrypto` run, and `pending` is true while a wallet's
 * NFTs have never been synced.
 */
export const getNfts = () => request('crypto/nfts');

/** Sets an NFT's cost and current value in USD. Both are sent every time;
 *  null clears one back to the figure derived from the chain. */
export const updateNft = (id, { costUsd, valueUsd }) =>
  request(`crypto/nfts/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify({ costUsd, valueUsd }),
  });
